module.exports = __webpack_public_path__ + "static/img/login-side_bg.439c2f30.png";